var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{style:(_vm.getClass),attrs:{"id":"razorpay-button"},on:{"click":function($event){return _vm.getRazorPayorder($event)}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }